/* eslint-disable no-unused-vars */
import ScenarioService from "@/services/scenario";

import { SET_SCENARIOS } from "./types";

export async function fetchScenarios({commit}) {
  const {data} = await ScenarioService.list();
  const scenarios = data.data.scenarios;
  commit(SET_SCENARIOS, scenarios);
  return scenarios;
}

export async function getScenarioConfig({commit}, scenarioId) {
  const {data} = await ScenarioService.getConfigById(scenarioId);
  return  data.data?.doc?.raw_metadata;
}

export async function setScenarioConfig({commit}, params) {
  const {data} = await ScenarioService.setConfig(params);
  return data.data;
}